export const cropHealthEn = {
  cropHealth: {
    title: "Crop Health Dashboard",
    noDataAvailable: "No Data Available",
    noDataDesc: "Crop health data is not currently available for this parcel. Real data sources are required for analysis.",
    geographicAnalysis: "Geographic pest analysis and recommendations for your {{crop}} crop at {{lat}}, {{lon}}",
    overview: "📊 Overview",
    pestsAndDiseases: "🐛 Pests & Diseases",
    irrigation: "💧 Irrigation",
    harvest: "🌾 Harvest",
    imageAnalysis: "📷 Image Analysis",
    overallHealth: "Overall Health",
    excellentHealth: "Excellent Health",
    moderateHealth: "Moderate Health",
    poorHealth: "Poor Health",
    highRiskPests: "High Risk Pests",
    pestsAnalyzed: "Pests Analyzed",
    currentClimate: "Current Climate Conditions",
    temperature: "Temperature",
    humidity: "Humidity",
    precipitation: "Precipitation",
    geographicPestAlert: "Geographic pest analysis based on your location and real-time climate data for {{crop}} cultivation.",
    verifyBeforeTreatment: "Multiple Data Sources - Verify Before Any Intervention",
    officialSources: "Official Sources (🟢 EPPO, 🟡 CABI):",
    officialSourcesDesc: "Verified databases from official institutions.",
    aiResearch: "AI Research (🔵 Perplexity):",
    aiResearchDesc: "AI-generated information based on scientific literature.",
    consultAgronomist: "Not verified by official institutions. Consult with your agronomist before any intervention decision.",
    climateRiskNote: "Climate risk scores are calculated using real weather data and may vary.",
    geographicPestRisk: "Geographic Pest Risk Assessment",
    activeThisMonth: "Active this month",
    inactiveSeason: "Inactive season",
    optimalConditions: "Optimal conditions",
    climateCorrelation: "Climate Correlation",
    prevention: "Prevention",
    treatmentOptions: "Review options",
    noPestRisks: "No significant pest risks detected for your location and crop type.",
    geographicDiseaseRisk: "Geographic Disease Risk Assessment",
    soilMoistureAnalysis: "Soil Moisture Analysis",
    realData: "🛰️ Real Data",
    simulated: "Simulated",
    currentSoilMoisture: "Current Soil Moisture",
    optimal: "Optimal",
    irrigationRecommendation: "Irrigation Recommendation",
    nextIrrigation: "Next Irrigation",
    estimatedVolume: "Estimated Volume",
    criticalWaterStress: "Critical water stress detected. Immediate irrigation required!",
    highWaterStress: "High water stress detected. Irrigation needed within 24 hours.",
    waterStressDetected: "Water stress detected. Increase irrigation frequency.",
    environmentalConditions: "Environmental Conditions",
    soilMoistureStatus: "Soil Moisture Status",
    waterStressLevel: "Water Stress Level",
    dataSource: "Data Source",
    realTimeSatellite: "🛰️ Real-Time Satellite",
    simulatedData: "📊 Simulated",
    realDataNote: "Soil moisture from NASA satellite data",
    simulatedDataNote: "Consider upgrading to real-time soil moisture monitoring for precise irrigation decisions",
    harvestPrediction: "Harvest Prediction",
    estimatedHarvestDate: "Estimated Harvest Date",
    qualityForecast: "Quality Forecast",
    yieldEstimate: "Yield Estimate",
    harvestDataSourceNote: "Predictions based on {{source}}",
    realCropData: "real NDVI, climate, and weather data",
    simulatedCropData: "simulated crop health patterns",
    harvestAlert: "Harvest predictions are based on current crop health, weather patterns, and historical data for {{crop}} in your region.",
    aiCropDiagnosis: "AI Crop Diagnosis",
    aiCropDiagnosisDesc: "Upload a clear photo of your crop for instant AI-powered pest and disease diagnosis",
    removeImage: "Remove Image",
    analyzeImage: "Analyze Image",
    analyzing: "Analyzing...",
    uploadCropImage: "Upload Crop Image",
    supportedFormats: "Supported formats: JPEG, PNG, WebP (Max 10MB)",
    analyzingCropImage: "Analyzing Crop Image",
    analyzingCropImageDesc: "AI is examining the image for pests, diseases, and nutritional deficiencies...",
    analyzingTime: "This typically takes 15-30 seconds",
    aiDiagnosisComplete: "AI Diagnosis Complete",
    imageTip: "For best results, take clear photos of affected leaves, stems, or fruits with good lighting. AI can assist with visual crop diagnosis and suggest possible issues. Validate results with field scouting before any intervention decision.",
    invalidFileType: "Invalid file type",
    invalidFileTypeDesc: "Please upload an image file (JPEG, PNG, etc.)",
    fileTooLarge: "File too large",
    fileTooLargeDesc: "Please upload an image smaller than 10MB",
    analysisComplete: "Analysis complete",
    analysisCompleteDesc: "Image analyzed successfully",
    analysisFailed: "Analysis failed",
    analysisFailedDesc: "Failed to analyze image. Please try again.",
    calculationNote: "Based on average pest and disease risk scores. Formula: 100 - (pest risks + disease risks + irrigation penalty)",
    irrigationTimingMovedNote: "This dashboard shows observed soil moisture and water-stress state only. Open the Irrigation module for scheduling and volume guidance.",
    legacyCompositeTitle: "Legacy composite crop-health indicator — reference only",
    legacyCompositeNote: "This composite mixes several unrelated signals (catalogue pest scores, catalogue disease scores and a water-stress penalty). It is not the canonical local pest-risk status: use the phytosanitary status header on the Pest & Disease module for the parcel-level conclusion.",
    catalogueHighRiskPests: "Catalogue pests marked high risk (reference)",
    catalogueReferenceOnly: "External reference indicator — not connected to the canonical parcel status",
    weatherReferenceNote: "Percentages shown in these geographic cards are external catalogue/weather reference indicators. They are not the parcel-scoped canonical weather suitability.",
    calculationLabel: "Calculation",
    dataSourcesLabel: "Data sources",
    realtimeClimateLabel: "Real-time climate",
    harvestCalculationBreakdown: "Calculation breakdown",
    harvestBaseYield: "Base yield",
    harvestNdviAdjustment: "NDVI adj.",
    harvestWeatherAdjustment: "Weather adj.",
    harvestStressAdjustment: "Stress adj.",
    harvestRiskFactors: "Risk factors",
    harvestReviewNotes: "Review notes",
    harvestConfidence: "confidence",
    harvestNdviPoints: "NDVI: {{count}} points",
    harvestWeatherSource: "Weather: {{source}}",
    harvestNutrientReviewNote: "Review possible nutrient stress using current soil/foliar evidence and a qualified agronomist.",
    harvestSource: {
      simulated: "Simulated model",
      ai_model: "AI model — real satellite and weather data"
    },
    waterStress: {
      none: "None",
      mild: "Mild",
      moderate: "Moderate",
      severe: "Severe"
    },
    quality: {
      excellent: "Excellent",
      good: "Good",
      average: "Average",
      belowAverage: "Below average",
      poor: "Poor",
      unknown: "Unknown"
    },
    crops: {
      wheat: "Wheat",
      barley: "Barley",
      corn: "Corn",
      maize: "Corn",
      sunflower: "Sunflower",
      olive: "Olive grove",
      vineyard: "Vineyard",
      almond: "Almond",
      citrus: "Citrus",
      rice: "Rice",
      potato: "Potato",
      tomato: "Tomato"
    },
    aiReasoning: "AI reasoning",
    dataQualityHigh: "High quality data",
    dataQualityMedium: "Medium quality data",
    dataQualityLimited: "Limited data",
    moistureStatus: {
      critical: "Critical status",
      low: "Low status",
      optimal: "Optimal status",
      high: "High status"
    },
    noImageSelected: "No image selected",
    noImageSelectedDesc: "Please upload an image first"
  },
  cropHealthWater: {
    externalReferenceBadge: "External reference indicator",
    externalReferenceNote:
      "Live provider response (NASA POWER). This is an external reference moisture indicator, not persisted parcel evidence and not canonical parcel water-stress evidence. It is not used to unlock FAO-56 gates and not used to schedule or execute irrigation."
  },
  pestRisk: {
    levels: {
      high: "High risk",
      medium: "Moderate risk",
      low: "Low risk",
      minimal: "Minimal risk"
    },
    indicator: {
      epidemiological_model: "Epidemiological model",
      weather_conditions: "Weather suitability indicator"
    },
    treatmentDecisionNote: "Control decisions require review by your agronomist. SentinelCrop does not suggest products, doses or applications.",
    consultAgronomist: "Consult your agronomist for control decisions."
  }
};

export const pestCanonicalEn = {
  pestCanonical: {
    headerTitle: "Phytosanitary status",
    epidemiologicalRisk: "Epidemiological risk",
    weatherSuitability: "Weather suitability",
    evidenceConfidence: "Evidence confidence",
    fieldConfirmation: "Field confirmation",
    notAvailable: "Not available",
    confidence: {
      high: "High",
      medium: "Medium",
      low: "Low",
      data_limited: "Data limited"
    },
    confidenceCapNote: "Confidence cannot be High without field scouting and a crop-stage (phenology) signal.",
    waterEvidenceNote: "No parcel-scoped water evidence is available. An external reference moisture indicator may be available in Crop Health, but it is not persisted parcel evidence and is not used for this risk assessment.",
    weatherNotConnectedNote: "Weather suitability is not connected to this parcel yet. Percentage indicators shown in the geographic pest cards are external reference values and do not feed this canonical status.",
    confirmation: {
      confirmed: "Confirmed in field",
      not_confirmed: "Checked, no issue reported",
      missing: "Not confirmed in field"
    },
    gddFreshness: {
      current: "Up to date",
      recent: "Recent",
      stale: "Outdated",
      missing: "Missing"
    },
    gddAsOf: "as of {{date}}",
    gddStaleHint: "The stored GDD accumulation has not been recalculated recently, so it may not match current risk signals.",
    gddSourceLabel: "Source"
  }
};
